import { watchEffect, toValue, onBeforeUnmount, type MaybeRefOrGetter } from "vue";

// Verrou de scroll du body partagé (compteur de références : plusieurs overlays peuvent
// l'acquérir en même temps, on ne relâche qu'au dernier). Pur DOM → web + mobile.
let lockCount = 0;
let originalOverflow = "";

function acquire() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
}

function release() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) document.body.style.overflow = originalOverflow;
}

export function useAppScrollLock(locked: MaybeRefOrGetter<boolean>) {
  let acquired = false;

  watchEffect(() => {
    const v = toValue(locked);
    if (v && !acquired) {
      acquire();
      acquired = true;
    } else if (!v && acquired) {
      release();
      acquired = false;
    }
  });

  onBeforeUnmount(() => {
    if (acquired) {
      release();
      acquired = false;
    }
  });
}
